<h2 mat-dialog-title>Add Comment</h2>

<div mat-dialog-content class="dialog-wrapper">
  <div class="selection-preview" *ngIf="data.selectionText">
    <mat-icon class="selection-icon" aria-hidden="true">format_quote</mat-icon>
    <div class="selection-text">
      <strong>Selection:</strong>
      <em>{{ data.selectionText }}</em>
    </div>
  </div>

  <div class="content-field">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Comment</mat-label>
      <textarea
        #commentTextarea
        matInput
        [formControl]="content"
        rows="6"
        placeholder="Enter comment"
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="8"
      ></textarea>
    </mat-form-field>
  </div>
</div>

<div mat-dialog-actions align="end" class="actions">
  <button class="aker-flat-button" mat-button type="button" (click)="cancel()">Cancel</button>
  <button
    class="aker-context-button"
    mat-raised-button
    color="primary"
    type="button"
    (click)="save()"
    [disabled]="content.invalid || !content.value?.toString().trim()"
  >
    Save
  </button>
</div>
